<template>
  <v-app>

    <Navbar />

    <v-main>
      <router-view />
    </v-main>

    <Footer />
    
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar"
import Footer from "@/components/Footer"
import axios from 'axios'

export default {
  name: 'App',
  components: { Navbar, Footer },
  data: () => ({
    //
  }),
  async created() {
    // Check if there is a new version every 1 minute,
    // but only when the window is active/visible

    // Figure out how the visibility API works in this browser
    // https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API?redirectlocale=en-US&redirectslug=DOM%2FUsing_the_Page_Visibility_API
    // Set the name of the hidden property
    let hidden = null
    if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support 
      hidden = "hidden"
    } else if (typeof document.msHidden !== "undefined") {
      hidden = "msHidden"
    } else if (typeof document.webkitHidden !== "undefined") {
      hidden = "webkitHidden"
    }

    const resp = await axios.get(document.location.origin)
    const etag = resp.headers.etag
    setInterval(async () => {
      // Only make a HTTP request if the page is actively being used
      if (!document[hidden]) {
        const resp = await axios.get(document.location.origin)
        if (etag !== resp.headers.etag) {
          // A new version has been loaded
          // Ask the user for permission to reload the page
          const res = await this.$confirm('A new version of LessonSquared is available. Click OK to reload the page', {
            buttonTrueText: 'OK',
            buttonFalseText: 'Cancel',
          })
          if (res === true) {
            document.location.reload()
          }
        }
      }
    }, 60000)
  }
}
</script>

<style scoped>
  .v-application {
    background-color: #f5f5f5 !important;
  }
</style>
